"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShouldSeeVidyardShepherd = getShouldSeeVidyardShepherd;

var _VidyardAPI = require("crm_ui/extensions/vidyard/VidyardAPI");

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _dateHelpers = require("crm_ui/utils/dateHelpers");

var vidyardRevisitThresholdDays = 30;

function getShouldSeeVidyardShepherd() {
  var portalId = _hubspot.default.get();

  return (0, _VidyardAPI.getUsersVidyardStatus)(portalId).then(function (response) {
    var attribute = response.objects.find(function (a) {
      return a.portal_id === portalId;
    });
    var isFirstTimeVidyardUser = !(attribute && attribute.id);
    var userShouldRevisitVidyard = !isFirstTimeVidyardUser && Math.abs((0, _dateHelpers.getDaysFromToday)(attribute.updated)) > vidyardRevisitThresholdDays;
    return isFirstTimeVidyardUser || userShouldRevisitVidyard;
  });
}